export default "__VITE_ASSET__07d30b4a__"